import Typography from '@pedidosya/web-fenix/foundations/Typography';
import styled from 'styled-components';
import { TagWeb } from '../styles/styles';
import { vendorItem as vendorItemTokens } from '../styles/vendorItem';

const textProps = vendorItemTokens.properties.fonts;
const vendorItemStyles = vendorItemTokens.categories.default;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

const ActionContainer = styled.div`
  margin-top: ${({ theme }) =>
    theme.space(vendorItemStyles.shared['status-large-row-gap'])};
`;

export const VendorStatusLarge = ({ title, action }) => (
  <Container>
    <Typography
      color={textProps.vendorStatusLarge['text-color']}
      token={textProps.vendorStatusLarge.typography}
    >
      {title}
    </Typography>

    {!!action && (
      <ActionContainer>
        <TagWeb
          className="vendor-status-action"
          category="informative"
          size="medium"
          label={action}
        />
      </ActionContainer>
    )}
  </Container>
);
